import styled, { css } from 'styled-components'
import { BaseColorWithDeep, NeutralColorWithDeep } from '@/shared/Types/Cura'

export const SidebarWrapper = styled.aside<{
  $hasBorder?: boolean
  $marginBottom?: string
}>`
  ${({ $hasBorder = true, theme, $marginBottom = '2.5rem' }) => css`
    display: flex;
    flex-direction: column;
    max-width: 603px;
    border-right: ${$hasBorder
      ? `1px solid ${theme.colors.getColor('neutral-light')}`
      : 'none'};

    margin-bottom: 2.5rem;

    width: 100%;

    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      width: 100%;
      margin-bottom: ${$marginBottom};
      padding-top: 16px;
      border-right: none;
      align-items: center;
      padding: 0;
    }
  `}
`

export const ContentWithPadding = styled.div`
  ${({ theme }) => css`
    padding: 0;

    @media screen and (min-width: ${theme.breakpoints.get('medium', 'max')}px) {
      padding-right: 24px;
    }
  `}
`

export const Body = styled.div`
  margin-top: 30px;
`

export const Title = styled.div<{
  color?: BaseColorWithDeep | NeutralColorWithDeep
}>`
  ${({ theme, color }) => css`
    &:after {
      content: '';
      display: block;
      width: 66px;
      height: 2px;
      margin-top: 16px;
      background: ${color
        ? theme.colors.getColor(color)
        : theme.colors.getColor('primary-lighter')};
    }

    @media (max-width: ${theme.breakpoints.get('medium', 'max')}px) {
      text-align: center;

      &:after {
        margin: 16px auto 0;
      }
    }
  `}
`
